import request from 'utils/request';

const PREFIX = '/api/adv-invoice-app/';

export const AdvInvoiceAppAPI = {
  LIST: PREFIX + 'list',
  ADD: PREFIX + 'add',
  AUDIT: PREFIX + 'audit',
  PREVIEW: PREFIX + 'preview',
  INVOICE_PREVIEW: PREFIX + 'invoice-preview',
};

export function getAdvInvoiceAppList(data) {
  return request({
    url: AdvInvoiceAppAPI.LIST,
    method: 'post',
    data,
  });
}

export function addAdvInvoiceApp(data) {
  return request({
    url: AdvInvoiceAppAPI.ADD,
    method: 'post',
    data,
  });
}

export function auditAdvInvoiceAppStatus(data) {
  return request({
    url: AdvInvoiceAppAPI.AUDIT,
    method: 'post',
    data,
  });
}

export function getAdvInvoiceAppPreviewData(data) {
  return request({
    url: AdvInvoiceAppAPI.PREVIEW,
    method: 'post',
    data,
  });
}

export function invoicePreview(data) {
  return request({
    url: AdvInvoiceAppAPI.INVOICE_PREVIEW,
    responseType: 'blob',
    method: 'post',
    data,
  });
}
